import React from 'react';
import Link from 'gatsby-link';

const Footer = () => (
  <footer className="footer footer-dark">
    <div className="container">
      <div className="columns footer-columns is-flex-mobile">
        <div className="column is-half-mobile">
          <div className="footer-column">
            <div className="footer-header">
              <h3>Company</h3>
            </div>
            <ul className="link-list">
              <li>
                <Link to="/"> Home </Link>
              </li>
              <li>
                <Link to="/why-us"> Why Us </Link>
              </li>
              <li>
                <Link to="/how-we-work"> How We Work </Link>
              </li>
              <li>
                <a href="#contact-form">Contact</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="column is-half-mobile">
          <div className="footer-column">
            <div className="footer-header">
              <h3>Technology</h3>
            </div>
            <ul className="link-list">
              <li>
                <Link to="/technologies/angular-js"> AngularJS </Link>
              </li>
              <li>
                <Link to="/technologies/react-js"> ReactJS </Link>
              </li>
              <li>
                <Link to="/technologies/node-js"> NodeJS </Link>
              </li>
              <li>
                <Link to="/technologies/django"> Django </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="column is-half-mobile">
          <div className="footer-column">
            <div className="footer-header">
              <h3> Services </h3>
            </div>
            <ul className="link-list">
              <li>
                <Link to="/capabilities/progressive-web-apps"> Progressive Web Apps </Link>
              </li>
              <li>
                <Link to="/capabilities/serverless"> Serverless </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="column is-half-mobile">
          <div className="footer-column" />
        </div>

        <div className="column is-half-mobile">
          <div className="footer-column">
            <p className="pt-10 pb-10">
              <a href="#contact-form" className="button button-cta btn-align btn-outlined is-bold light-btn rounded z-index-2">
                Let&apos;s build together
              </a>
            </p>

            <div className="copyright">
              <span className="moto light-text">
                Designed and Developed with
                <img src="/files/images/logos/footer/nodejs-logo.png" alt="" />
                <span>
                  {' '}
                  {'    '} {'  '}
                </span>
                <img src="/files/images/logos/footer/reactjs-logo.png" alt="" />
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer.jsx